export const eventConfig = {
  coupleNames: 'Jan und Michael',
  eventTitle: 'Freien Hochzeit',
  eventDate: '19.09.2026',
  locationName: 'Burg Bruch',
  locationAddressLine1: 'In der Burg 3',
  locationAddressLine2: '54518 Bruch',
  primaryPhoneLabel: 'Jan',
  primaryPhoneNumber: '+49 162 2685577',
  secondaryPhoneLabel: 'Michael',
  secondaryPhoneNumber: '+49 176 67775569',
}
